import { createContext } from 'react';
export const jwtContext = createContext<any>({});
